import { Ability, AbilityBuilder, AbilityClass } from "@casl/ability";
import { TokenData } from "@src/sudozi-schemas/token-data-schemas";

type Actions = "manage" | "create" | "read" | "update";
type Subjects =
  | "Plan"
  | "Plan Tracking"
  | "Integrations"
  | "Vendor"
  | "Settings"
  | "UsersInDepartmentSettings"
  | "User"
  | "Headcount"
  | "Mappings";
type AppAbility = Ability<[Actions, Subjects]>;
const AppAbility = Ability as AbilityClass<AppAbility>;

export default function abilitiesFor(
  user: TokenData | null,
  departmentIds?: string[],
): AppAbility {
  const { can, build } = new AbilityBuilder(AppAbility);

  if (user?.hasAdminAccess) {
    can("manage", "Vendor");
    can("manage", "Settings");
    can("manage", "Mappings");
    can("manage", "User");
    can("manage", "Plan");
    can("manage", "Integrations");
    can("manage", "Headcount");
  } else if (user?.hasSuperViewerAccess) {
    can("manage", "Vendor");
    can("manage", "User");
    can("manage", "Plan");
    can("manage", "Headcount");
  } else if (user?.hasDepartmentAccess || user?.hasBusinessUnitAccess) {
    can("read", "Plan Tracking");
    can("read", "Plan");
    can("manage", "UsersInDepartmentSettings");
    can("create", "Vendor");

    if (user?.departmentIds.some((did) => departmentIds?.includes(did))) {
      can("update", "User");
    }
  }

  if (user?.hasUserAdminAccess) {
    can("manage", "User");
  }

  if (user?.hasAdminAccess) {
    can("manage", "Plan Tracking");
  } else if (user?.hasFinancialAnalysisAccess) {
    can("read", "Plan Tracking");
  }
  return build();
}
